import { render, staticRenderFns } from "./PDFShow.vue?vue&type=template&id=40bc1f90&"
import script from "./PDFShow.vue?vue&type=script&lang=js&"
export * from "./PDFShow.vue?vue&type=script&lang=js&"
import style0 from "./PDFShow.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports